import React, { useState, useRef, useEffect } from 'react';

const MaskableKey = ({ value }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  return (
    // <span
    //   ref={ref}
    //   className='pointer'
    //   style={{ cursor: 'pointer' }}
    //   onClick={() => setVisible(true)}
    // >
    //   {visible ? value : '••••••••••'}
    // </span>
    // with eye icon
    <span ref={ref} className='maskable-key'>
      <span className='masked-text'>{visible ? value : '••••••••••'}</span>
      <i
        className={`fas ${visible ? 'fa-eye-slash' : 'fa-eye'} pointer`}
        style={{ cursor: 'pointer', color: '#007BFF', marginLeft: '4px' }}
        onClick={() => setVisible((prev) => !prev)}
      />
    </span>
  );
};
export default MaskableKey;
